export default "__VITE_ASSET__9WtDGl5i__"